const FAQS = [
  {
    id: 1,
    q: '玫瑰视频有哪些平台的影视资源？',
    a: '玫瑰视频汇集了香蕉视频、糖豆视频、小蓝视频和蓝莓视频等多个主流平台的优质内容，涵盖电视剧全集、电影大全及最新影视资源，一站聚合满足你的追剧需求。',
  },
  {
    id: 2,
    q: '观看需要付费吗？播放会卡顿吗？',
    a: '玫瑰视频提供的影视资源均为免费高清在线观看，全站采用优化播放技术，确保高清流畅不缓冲的观影体验，让你告别卡顿烦恼。',
  },
  {
    id: 3,
    q: '内容更新频率如何？新剧多久上线？',
    a: '我们的内容团队每日更新，热门新剧和电影第一时间上线。香蕉视频和糖豆视频的最新剧集通常在播出后数小时内即可在玫瑰视频找到。',
  },
  {
    id: 4,
    q: '支持哪些设备观看？',
    a: '玫瑰视频全面支持PC电脑、平板和手机端观看，无需安装任何插件。推荐使用移动端获得随时随地追剧的便捷体验，高清画质自动适配不同设备。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[800px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100/70 text-primary-700 text-xs font-medium mb-3">
            常见疑问
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-2">常见问题</h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            快速了解玫瑰视频的使用方式
          </p>
        </div>

        <div className="space-y-3">
          {FAQS.map((faq) => (
            <details
              key={faq.id}
              className="group rounded-xl border border-background-200/70 bg-background-50 overflow-hidden"
              open={faq.id === 1}
            >
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none hover:bg-background-100/50 transition-colors">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 pr-4">{faq.q}</h3>
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-background-200 flex items-center justify-center group-open:rotate-45 transition-transform duration-200">
                  <i className="ri-add-line text-sm text-foreground-600"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}